import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RestaurantProfile } from '../../../models/List.Restaurant';
import { RestaurantService } from '../../../services/Restaurant.service';

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html'
})
export class BasicInfoComponent implements OnInit {
  @Input() restaurantProfile?: RestaurantProfile;

  dataLoading = false;
  lang = localStorage.getItem('language') || 'en';

  // Restaurant ID
  restaurantId?: any;
  constructor(private route: ActivatedRoute,
    public translate: TranslateService,
    private router: Router,
    private service: RestaurantService) {
    this.route.params.subscribe(params => {
      this.restaurantId = params['id'];
    });
  }

  ngOnInit(): void {
    this.restaurantId = this.restaurantProfile?.id
  }

  DeleteRestaurant() {
    Swal.fire({
      title: this.translate.instant('swalMsg.Areyousuretodelete'),
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yesdeleteit'),
      cancelButtonText: this.translate.instant('swalMsg.Nokeepit')
    }).then((result) => {
      if (result.value) {
        this.dataLoading = true;
        this.service.DeleteRestaurant(this.restaurantId).subscribe(
          (data: any) => {
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.deletededsuccessfuly'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.router.navigate(['/admin/restaurants'])
            }
          },
          (error: any) => {
            this.dataLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          });
      }
    });
  }
}
